export const palette = {
    background: {
        dark: '#070936',
        light: '#EFEFEF',
        paper: '#F5F4EF',
        cream: '#ECE9DC',
        warm: '#f2ede7',
        white: '#FFFFFF',
        footer: '#27284A',
    },
    primary: {
        main: '#08BCFB',
        dark: '#14A5F1',
        blue: '#2563EB',
        accent: '#B558FF',
        purple: '#a686cb',
        lavender: '#CBAEE2',
    },
    text: {
        primary: '#222222',
        secondary: '#666666',
        muted: '#79828E',
        dark: '#333333',
        darkest: '#111827',
        white: '#FFFFFF',
    },
    border: {
        light: '#DADDE3',
        medium: '#E0E0E0',
        dark: '#333333',
        input: '#CCCCCC',
    },
    status: {
        error: '#E05A5A',
        errorLight: '#ffebee',
        errorBorder: '#ffcdd2',
        errorDark: '#c62828',
    },
    surface: {
        overlay: '#ffffffcf',
        overlayLight: '#ffffffc7',
        skeleton: 'rgb(199 187 187 / 11%)',
        glass: '#eeeeee96',
        glassDark: '#eeeeee47',
        gray: '#F0F0F0',
        grayLight: '#F5F5F5',
        chatBubble: '#D8E7FD',
        chatBubbleAgent: '#F3E9E9',
        inputBg: '#E6E8EE',
        midnight: '#1a1a2e',
        darkBlue: '#040924',
    },
    brand: {
        gold: '#B4996D',
        teal: '#00D3C1',
        orange: '#FF6B35',
        cyan: '#42c6df',
        skyBlue: '#55D4EF',
        indigo: '#90A5F0',
        efeded: '#efeded',
    },
    map: {
        route: '#3b82f6',
        marker: '#3b82f6',
    },
} as const;

const themes = {
    default: {
        background: {
            main: '#070936',
            footer: '#27284A',
            skeletons: 'rgb(199 187 187 / 11%)',
        },
        primary: '#08A4E1',
        text: {
            main: 'white',
        },
        components: {
            footerButton: {
                backgroundColor: 'transparent',
                border: '1.5px solid #14A5F1'
            },
            message: {
                client: {
                    icon: '#E6E8EE',
                    message: '#D8E7FD'
                },
                agent: {
                    icon: 'rgb(191, 22, 51)', //should be dynamic according to client logo color (?)
                    message: '#F3E9E9'
                }
            }
        }
    },
    light: {
        background: {
            main: '#EFEFEF',
            footer: '#070936',
            skeletons: 'black',
        },
        primary: 'black',
        text: {
            main: 'black',
            footerButton: '#FFFFFFE'
        },
        components: {
            footerButton: {
                backgroundColor: 'black',
                border: 'black'
            }
        }
    }
};
export default themes;


export const defaultTheme = {
    palette: {
        background: {
            default: '#070936'
        },
        primary: {
            main: '#08A4E1' // highlight subtitle
        },
        secondary: {
            main: '#27284A' // footer
        },
        text: '#FFFFFFE',
    },
    custom: {
        footerButton: 'transperent',
    },
    components: {
        MuiSkeleton: {
            styleOverrides: {
                root: {
                    backgroundColor: '#FFFFFF'
                }
            }
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    backgroundColor: '#FFFFFF'
                }
            }
        }
    }
};

export const lightTheme = {
    palette: {
        background: {
            default: '#FFFFFFE'
        },
        primary: {
            main: '#000000'
        },
        secondary: {
            main: '#070936'
        },
        text: '#000000'
    },
    custom: {
        footerButton: '#000000',
        text: '#FFFFFFE'
    },
    components: {
        MuiSkeleton: {
            styleOverrides: {
                root: {
                    backgroundColor: 'rgb(199 187 187 / 11%)'
                }
            }
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    backgroundColor: '#FFFFFF'
                }
            }
        }
    }
};
